import StyledTooltip from './Tooltip'
import ConditionalTooltip from './ConditionalTooltip'

export default StyledTooltip

export { ConditionalTooltip }
